import { Routes, Route, useNavigate } from "react-router-dom";

import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";

import Login from "./scenes/login/Login";
import Dashboard from "./scenes/dashboard/Dashboard";

import { MsalProvider } from "@azure/msal-react";
import { NavigationClient } from "@azure/msal-browser";

import SecuredShell from "./scenes/shell/SecuredShell";
import Mapping from "./scenes/mapping/Mapping";
import Events from "./scenes/events/Events";
import Runs from "./scenes/runs/Runs";
import Transactions from "./scenes/transactions/Transactions";
import Users from "./scenes/users/Users";
import Configs from "./scenes/configs/Configs";
import Augmentation from "./scenes/augmentation/Augmentation";

class CustomNavigationClient extends NavigationClient {
  constructor(navigate) {
    super();
    this.navigate = navigate;
  }

  /**
   * Navigates to other pages within the same web application
   * Use the useNavigate hook provided by react-router-dom to take advantage of client-side routing
   * @param url
   * @param options
   */
  async navigateInternal(url, options) {
    const relativePath = url.replace(window.location.origin, "");
    if (options.noHistory) {
      this.navigate(relativePath, { replace: true });
    } else {
      this.navigate(relativePath);
    }

    return false;
  }
}

function App({ pca }) {
  const navigate = useNavigate();
  const navigationClient = new CustomNavigationClient(navigate);
  pca.setNavigationClient(navigationClient);

  const [theme, colorMode] = useMode();

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />

        {/* <div className="app"> */}
        <MsalProvider instance={pca}>
          {/* <AppSidebar isSidebar={isSidebar} /> */}
          {/* <main className="content"> */}
          {/* <Topbar setIsSidebar={setIsSidebar} /> */}
          <Routes>
            <Route index element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="secured" element={<SecuredShell />}>
              <Route path="" element={<Dashboard />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="runs" element={<Runs />} />
              <Route path="transactions" element={<Transactions />} />
              <Route path="mappings" element={<Mapping />} />
              <Route path="events" element={<Events />} />
              <Route path="users" element={<Users />} />
              <Route path="configs" element={<Configs />} />
              <Route path="augmentation" element={<Augmentation />} />
            </Route>
          </Routes>
          {/* </main> */}
        </MsalProvider>
        {/* </div> */}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
